import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { IUserProfile } from '../../providers/user-provider';

interface AuthStore {
  userProfile: IUserProfile | null;
  setUserProfile: (profile: IUserProfile | null) => void;
  isRegionChanged: boolean;
  setIsRegionChanged: (value: boolean) => void;
}

export const useAuthStore = create<AuthStore>()(
  devtools(set => ({
    userProfile: null,
    setUserProfile: profile => set({ userProfile: profile }),
    isRegionChanged: false,
    enabled: true,
    setIsRegionChanged: value => set({ isRegionChanged: value }),
  })),
);
